<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-md-8 mx-auto">
        <!-- Notifications Dynamiques -->
        <div class="card mt-4">
          <div class="card-header p-3 d-flex justify-content-between align-items-center">
            <h5 class="mb-0">Notifications</h5>
            <button class="btn btn-outline-danger btn-sm" @click="markAllAsRead">
              TOUT MARQUER COMME LU
            </button>
          </div>

          <div class="card-body p-3">
            <div v-if="loading" class="text-center text-secondary">Chargement...</div>

            <div v-else-if="notifications.length === 0" class="text-center text-muted">
              Aucune notification
            </div>

            <div v-else class="list-group">
              <div
                v-for="notification in notifications"
                :key="notification.id"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <div>
                  <div class="fw-bold">{{ notification.data.message }}</div>
                  <div class="small text-secondary">
                    {{ formatDate(notification.created_at) }} —
                    <span class="badge bg-info text-white">
                      {{ notification.data.notification_type || 'N/A' }}
                    </span>
                  </div>
                </div>

                <span
                  class="badge"
                  :class="{
                    'bg-success': !notification.read_at,
                    'bg-secondary': notification.read_at
                  }"
                >
                  {{ notification.read_at ? 'Lu' : 'Non lu' }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'

const notifications = ref([])
const loading = ref(false)

const fetchNotifications = async () => {
  try {
    loading.value = true
    const response = await axios.get('/notifications')
    notifications.value = response.data.notifications.data
  } catch (error) {
    console.error('Erreur lors de la récupération des notifications :', error)
  } finally {
    loading.value = false
  }
}

const markAllAsRead = async () => {
  try {
    await axios.post('/notifications/mark-all-read')
    await fetchNotifications()
  } catch (error) {
    console.error('Erreur lors du marquage :', error)
  }
}

const formatDate = (dateStr) => {
  const date = new Date(dateStr)
  return date.toLocaleString()
}

onMounted(() => {
  fetchNotifications()
})
</script>

<style scoped>
.list-group-item {
  border: 1px solid #e1e1e1;
  border-radius: 6px;
  margin-bottom: 10px;
}
</style>
